import React, {
  useEffect,
  useState,
  useRef
} from "react";

import {
  FaEye,
  FaCheck,
  FaLock,
  FaTriangleExclamation,
  FaClock,
  FaArrowTrendUp
} from "react-icons/fa6";

import ReactDOM from "react-dom";

import axios from "axios";

// import "./TicketHistory.css";
import "./Support.css";

const API =
  "https://api.mahal.qa/api/v1/admin/support";

export default function TicketHistory() {

  const [tickets, setTickets] =
    useState([]);

  const [loading, setLoading] =
    useState(false);

  const [cursor, setCursor] =
    useState(null);

  const [hasMore, setHasMore] =
    useState(true);

  const [search, setSearch] =
    useState("");

  const [status, setStatus] =
    useState("");

  const [priority, setPriority] =
    useState("");

  const [queueId, setQueueId] =
    useState("");

  const [slaBreached, setSlaBreached] =
    useState("");

  const [escalatedOnly, setEscalatedOnly] =
    useState(false);

  const [reopenedOnly, setReopenedOnly] =
    useState(false);

  const [selectedTicket, setSelectedTicket] =
    useState(null);

  const [modalOpen, setModalOpen] =
    useState(false);
  const [previewFile, setPreviewFile] =
    useState(null);

  const [attachmentUrls, setAttachmentUrls] =
    useState({});

  const [summary, setSummary] =
    useState({
      resolved_count: 0,
      closed_count: 0,
      sla_breached_count: 0,
      avg_resolution_time: "0m",
      escalated_count: 0
    });

  const containerRef = useRef();

  const ADMIN_TOKEN =
    localStorage.getItem("admin_token");

  const ADMIN_ROLE =
    localStorage.getItem("admin_role");

  const headers = {
    Authorization: `Bearer ${ADMIN_TOKEN}`
  };

  useEffect(() => {

    fetchHistory(true);

  }, [
    search,
    status,
    priority,
    queueId,
    slaBreached,
    escalatedOnly,
    reopenedOnly
  ]);

  useEffect(() => {

    const loadAttachments =
      async () => {

        if (!selectedTicket) {
          return;
        }

        const map = {};

        for (const a of (
          selectedTicket.attachments || []
        )) {

          if (
            /\.(jpg|jpeg|png|gif|webp)$/i.test(
              a.file_name
            )
          ) {

            const url =
              await fetchAttachment(
                a.attachment_id
              );

            if (url) {

              map[
                a.attachment_id
              ] = url;
            }
          }
        }

        setAttachmentUrls(map);
      };

    if (modalOpen) {
      loadAttachments();
    }

  }, [
    modalOpen,
    selectedTicket
  ]);

  const fetchHistory = async (
    reset = false
  ) => {

    if (loading) {
      return;
    }

    try {

      setLoading(true);

      const res = await axios.get(
        `${API}/history`,
        {
          headers,
          params: {
            cursor:
              reset
                ? null
                : cursor,

            search,

            status,

            priority,

            queue_id:
              queueId || null,

            sla_breached:
              slaBreached || null,

            escalated_only:
              escalatedOnly,

            reopened_only:
              reopenedOnly,

            limit: 20
          }
        }
      );

      const data =
        res.data.data || [];

      setTickets(prev =>
        reset
          ? data
          : [...prev, ...data]
      );

      setCursor(
        res.data.next_cursor
      );

      setHasMore(
        !!res.data.next_cursor
      );

      if (res.data.summary) {
        setSummary(
          res.data.summary
        );
      }

    } catch (err) {

      console.error(err);

      alert(
        err?.response?.data?.error ||
        "Failed to load history"
      );

    } finally {

      setLoading(false);
    }
  };

  const openTicket = async (
    ticketId
  ) => {

    try {

      const res = await axios.get(
        `${API}/ticket/${ticketId}`,
        { headers }
      );

      setSelectedTicket(
        res.data
      );

      setModalOpen(true);

    } catch (err) {

      console.error(err);

      alert(
        err?.response?.data?.error ||
        "Failed to load ticket"
      );
    }
  };

  const handleScroll = () => {

    const el = containerRef.current;

    if (
      !el ||
      loading ||
      !hasMore
    ) {
      return;
    }

    if (
      el.scrollTop + el.clientHeight >=
      el.scrollHeight - 50
    ) {

      fetchHistory();
    }
  };

  const fetchAttachment = async (
    attachmentId
  ) => {

    try {

      const res = await axios.get(
        `${API}/attachment/${attachmentId}`,
        {
          headers,
          responseType: "blob"
        }
      );

      return URL.createObjectURL(
        res.data
      );

    } catch {

      return null;
    }
  };

  const formatDuration = (
    mins
  ) => {

    if (!mins && mins !== 0) {
      return "—";
    }

    const h = Math.floor(mins / 60);

    const m = mins % 60;

    if (h <= 0) {
      return `${m}m`;
    }

    return `${h}h ${m}m`;
  };

  return (

    <div className="support-page">

      <div className="support-header">

        <div>
          <h1>Ticket History</h1>

          <p>
            Operational archive and audit visibility
          </p>
        </div>

      </div>

      <div className="support-summary-grid">

        <div className="support-summary-card">
          <div className="support-summary-icon">
            <FaCheck />
          </div>

          <div className="support-summary-meta">
            <span>Resolved</span>
            <h2>{summary.resolved_count}</h2>
          </div>
        </div>

        <div className="support-summary-card">
          <div className="support-summary-icon">
            <FaLock />
          </div>

          <div className="support-summary-meta">
            <span>Closed</span>
            <h2>{summary.closed_count}</h2>
          </div>
        </div>

        <div className="support-summary-card">
          <div className="support-summary-icon">
            <FaTriangleExclamation />
          </div>

          <div className="support-summary-meta">
            <span>SLA Breaches</span>
            <h2>{summary.sla_breached_count}</h2>
          </div>
        </div>

        <div className="support-summary-card">
          <div className="support-summary-icon">
            <FaClock />
          </div>

          <div className="support-summary-meta">
            <span>Avg Resolution</span>
            <h2>{summary.avg_resolution_time}</h2>
          </div>
        </div>

        <div className="support-summary-card">
          <div className="support-summary-icon">
            <FaArrowTrendUp />
          </div>

          <div className="support-summary-meta">
            <span>Escalated</span>
            <h2>{summary.escalated_count}</h2>
          </div>
        </div>

      </div>


      <div className="support-filters">

        <input
          className="support-search"
          placeholder="Search..."
          value={search}
          onChange={(e) =>
            setSearch(
              e.target.value
            )
          }
        />

        <select className="support-select"
          value={status}
          onChange={(e) =>
            setStatus(
              e.target.value
            )
          }
        >

          <option value="">
            Status
          </option>

          <option value="resolved">
            Resolved
          </option>

          <option value="closed">
            Closed
          </option>

        </select>

        <select className="support-select"
          value={priority}
          onChange={(e) =>
            setPriority(
              e.target.value
            )
          }
        >

          <option value="">
            Priority
          </option>

          <option value="low">
            Low
          </option>

          <option value="normal">
            Normal
          </option>

          <option value="high">
            High
          </option>

        </select>

        <input
          className="support-search"
          placeholder="Queue ID"
          value={queueId}
          onChange={(e) =>
            setQueueId(
              e.target.value
            )
          }
        />

        <select className="support-select"
          value={slaBreached}
          onChange={(e) =>
            setSlaBreached(
              e.target.value
            )
          }
        >

          <option value="">
            SLA
          </option>

          <option value="true">
            Breached
          </option>

          <option value="false">
            Within SLA
          </option>

        </select>

        <label>

          <input

            type="checkbox"
            checked={escalatedOnly}
            onChange={(e) =>
              setEscalatedOnly(
                e.target.checked
              )
            }
          />

          Escalated

        </label>

        <label>

          <input
            type="checkbox"
            checked={reopenedOnly}
            onChange={(e) =>
              setReopenedOnly(
                e.target.checked
              )
            }
          />

          Reopened

        </label>

      </div>

      {/* ========================================= */}
      {/* TABLE */}
      {/* ========================================= */}

      <div
        className="support-table-wrap"
        ref={containerRef}
        onScroll={handleScroll}
      >

        <table className="support-table">

          <thead>

            <tr>

              <th>ID</th>

              <th>Subject</th>

              <th>Queue Flow</th>

              <th>Status</th>

              <th>Priority</th>

              <th>SLA</th>

              <th>Resolution</th>

              <th>Escalations</th>

              <th>Reopens</th>

              <th>Solved By</th>

              <th>Closed At</th>

              <th></th>

            </tr>

          </thead>

          <tbody>

            {tickets.map(t => (

              <tr
                key={t.ticket_id}
              >

                <td>
                  #{t.ticket_id}
                </td>

                <td>
                  {t.subject}
                </td>

                <td>
                  {/* <div className="th_flow"> */}
                  {
                    t.queue_flow ||
                    t.queue_name
                  }
                  {/* </div> */}
                </td>

                <td>

                  <span
                    className={`support-status is-${t.status}`}
                  >
                    {t.status}
                  </span>

                </td>

                <td>

                  <span
                    className={`support-priority ${t.priority}`}
                  >
                    {t.priority}
                  </span>

                </td>

                <td>

                  {t.sla_breached ? (

                    <span className="support-badge is-breached">
                      BREACHED
                    </span>

                  ) : (

                    <span className="support-badge is-sla-safe">
                      OK
                    </span>

                  )}

                </td>

                <td>
                  {formatDuration(
                    t.resolution_minutes
                  )}
                </td>

                <td>
                  {
                    t.escalation_count || 0
                  }
                </td>

                <td>
                  {
                    t.reopen_count || 0
                  }
                </td>

                <td>
                  {
                    t.resolved_by_name ||
                    t.closed_by_name ||
                    "—"
                  }
                </td>

                <td>
                  {
                    t.closed_at ||
                    t.resolved_at ||
                    "—"
                  }
                </td>

                <td>

                  <button
                    className="support-table-btn"
                    onClick={() =>
                      openTicket(
                        t.ticket_id
                      )
                    }
                  >
                    <FaEye />
                    View
                  </button>

                </td>

              </tr>
            ))}

          </tbody>

        </table>

      </div>

      {/* ========================================= */}
      {/* MODAL */}
      {/* ========================================= */}

      {modalOpen &&
        selectedTicket &&

        ReactDOM.createPortal(

          <div
            className="support-modal-overlay"
            onClick={() =>
              setModalOpen(false)
            }
          >

            <div
              className="support-modal"
              onClick={(e) =>
                e.stopPropagation()
              }
            >

              <div className="support-modal-header">

                <h2>
                  Ticket #
                  {
                    selectedTicket.ticket.ticket_id
                  }
                </h2>

                <button className="support-modal-close"
                  onClick={() =>
                    setModalOpen(false)
                  }
                >
                  ✕
                </button>

              </div>

              <div className="support-modal-body">

                {/* ================================= */}

                <div className="support-modal-section">

                  <h3>
                    Ticket Summary
                  </h3>

                  <div className="support-ticket-info">

                    <div>
                      <b>Subject</b>
                      <p>
                        {
                          selectedTicket.ticket.subject
                        }
                      </p>
                    </div>

                    <div>
                      <b>Status</b>
                      <p>
                        {
                          selectedTicket.ticket.status
                        }
                      </p>
                    </div>

                    <div>
                      <b>Priority</b>
                      <p>
                        {
                          selectedTicket.ticket.priority
                        }
                      </p>
                    </div>

                    <div>
                      <b>Queue</b>
                      <p>
                        {
                          selectedTicket.ticket.queue_name
                        }
                      </p>
                    </div>

                  </div>

                </div>

                {/* ================================= */}

                <div className="support-modal-section">

                  <h3>
                    Timeline
                  </h3>

                  {(selectedTicket.history || []).map(
                    (
                      h,
                      index
                    ) => (

                      <div
                        className="support-timeline-item"
                        key={index}
                      >

                        <div className="support-timeline-dot" />

                        <div>

                          <b>
                            {
                              h.old_status
                            }
                            {" → "}
                            {
                              h.new_status
                            }
                          </b>

                          <p>
                            {
                              h.created_at
                            }
                          </p>

                        </div>

                      </div>
                    )
                  )}

                </div>

                {/* ================================= */}

                <div className="support-modal-section">
                  <h3>
                    Attachments
                  </h3>

                  <div className="support-attachments">
                    {(selectedTicket.attachments || []).map(
                      a => (
                        <div
                          key={a.attachment_id}
                        >
                          {attachmentUrls[
                            a.attachment_id
                          ] ? (
                            <img
                              src={
                                attachmentUrls[
                                a.attachment_id
                                ]
                              }
                              alt={a.file_name}
                              onClick={() =>
                                setPreviewFile(
                                  attachmentUrls[
                                  a.attachment_id
                                  ]
                                )
                              }
                            />
                          ) : (
                            <button
                              className="support-table-btn"
                              onClick={async () => {
                                const url =
                                  await fetchAttachment(
                                    a.attachment_id
                                  );

                                if (url) {
                                  window.open(url);
                                }
                              }}
                            >
                              {a.file_name}
                            </button>
                          )}
                        </div>
                      )
                    )}
                  </div>
                </div>

                <div className="support-modal-section">
                  <h3>
                    Internal Notes
                  </h3>

                  {(selectedTicket.internal_notes || []).map(
                    (n, index) => (
                      <div
                        className="support-note"
                        key={index}
                      >
                        <p>{n.note}</p>

                        <span>
                          {
                            n.created_at
                          }
                        </span>
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>
          </div>,
          document.body
        )}

      {previewFile &&
        ReactDOM.createPortal(
          <div
            className="support-modal-overlay"
            onClick={() =>
              setPreviewFile(null)
            }
          >
            <img
              src={previewFile}
              alt="Preview"
              className="support-preview-image"
            />
          </div>,
          document.body
        )}
    </div>
  );
}